import { ReportTemplate } from 'api/endPoints/GetReportTemplateList';

const FORESIGHT_EMAIL_DOMAIN = ['foresight.works', 'kc.works'];

export const getTemplateById = (templateId: number, reportTemplateList: ReportTemplate[]) => {
    const template = reportTemplateList?.find((template) => template.id === templateId);
    return template || null;
};
// If the template was created by admin from the foresight domain then show foresight logo
export const isTemplateBuiltByForesight = (email: string) => {
    if (email === undefined) return false;
    const [username, userDomain] = email.toLowerCase().split('@');
    if (!username || !userDomain) return false;
    if (username !== 'admin') return false;
    const isForesightDomain = FORESIGHT_EMAIL_DOMAIN.some(
        (domain) => userDomain === domain || userDomain.endsWith(`.${domain.toLowerCase()}`),
    );
    return isForesightDomain;
};
